module.exports = __webpack_public_path__ + "static/parade-2019-house08-3f47d8d747cd6907da5f640844064a85.jpg";